@if (consent.bannerVisible()) {
  <section
    class="fixed bottom-0 inset-x-0 z-50 border-t border-base-content/10 bg-base-200 shadow-lg"
    role="dialog"
    aria-labelledby="analytics-consent-title"
    aria-describedby="analytics-consent-description"
  >
    <div
      class="mx-auto flex w-full max-w-[1200px] flex-col gap-4 p-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6 sm:p-6"
    >
      <div class="flex min-w-0 flex-col gap-2">
        <h2 id="analytics-consent-title" class="text-base font-semibold text-base-content">
          Cookies и аналитика
        </h2>
        <p id="analytics-consent-description" class="text-sm text-base-content/80">
          Мы используем cookies и сервис Яндекс.Метрика для сбора обезличенной статистики посещений,
          чтобы улучшать работу сервиса. Вы можете принять или отклонить аналитику.
          @if (privacyPolicyLink(); as link) {
            <a [routerLink]="link" class="link link-accent link-hover ml-1">Подробнее</a>
          }
        </p>
      </div>
      <div class="flex shrink-0 flex-wrap gap-2 sm:justify-end">
        <button
          type="button"
          class="btn btn-ghost"
          aria-label="Отклонить использование cookies и аналитики"
          (click)="decline()"
        >
          Отклонить
        </button>
        <button
          type="button"
          class="btn btn-primary"
          aria-label="Принять использование cookies и аналитики"
          (click)="accept()"
        >
          Принять
        </button>
      </div>
    </div>
  </section>
}
